
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getRegionList } from '@/api/ccx'

@Component
export default class addrPopup extends Vue {
  @Prop({ default: '' }) defaulId?: string
  @Prop({ default: '' }) defaulName?: string
  @Prop({ default: '' }) title?: string

  @Watch('defaulId', { immediate: true })
  idChange() {
    this.addressId = this.defaulId
  }

  @Watch('popShow', { immediate: true })
  showChange(val) {
    if (val) {
      this.addressId = this.defaulId
    }
  }

  @Watch('defaulName', { immediate: true })
  nameChange() {
    this.addressName = this.defaulName
  }

  popShow = false

  addressName = '' // 地址名称
  addressId = '' // 地址Id

  options = []
  maxRegionType = 3 // 1省 2市 3区

  fieldNames = { text: 'regionName', value: 'regionId', children: 'children' }

  created() {
    this.getRegionListFunc(1)
  }

  showPop() {
    this.popShow = true
  }

  getRegionListFunc(regionType, parentId = '') {
    getRegionList({ regionType, parentId }).then((res) => {
      this.options = res.data.map((item) => {
        return {
          ...item,
          children: [],
          regionType
        }
      })
      console.log(this.options)
    })
  }

  // 动态加载children数据
  onChange({ selectedOptions }) {
    const targetOption = selectedOptions[selectedOptions.length - 1] || {}
    // 查到区 或者 已经查到children就不查了
    if (
      targetOption.regionType === this.maxRegionType ||
      targetOption.children.length > 0
    ) {
      return false
    }
    targetOption.children = []
    targetOption.regionType += 1
    getRegionList({
      regionType: targetOption.regionType,
      parentId: targetOption.regionId
    }).then((res) => {
      targetOption.children = res.data.map((item) => {
        const data = {
          ...item,
          regionType: targetOption.regionType
        }
        // 区没有children
        if (targetOption.regionType !== this.maxRegionType) data.children = []
        return data
      })
      this.options = [...this.options]
    })
  }

  onFinish({ value, selectedOptions }) {
    this.popShow = false
    this.addressId = value
    this.addressName = selectedOptions
      .map((option) => option[this.fieldNames.text])
      .join('')
    this.$emit('confirm', {
      addressId: this.addressId,
      addressName: this.addressName
    })
  }
}
